import { UPTODATE_NEEDED_ICON, MODIFIED, CONFLICT, POTENTIAL_CONFLICT } from './Constants';
import StringUtil from './StringUtil';
import { ThemeSetup } from '../themes/ThemeSetup';
import { isNonAliveAsset } from './SelectedItemUtil';

function isVersioned(item: RepoItem) {
  return item && item.wcStatusObject && StringUtil.isNotEmpty(item.wcStatusObject._localPath);
}

function isItemNotInSync(item: RepoItem) {
  return item.wcStatusObject._wcStatus == UPTODATE_NEEDED_ICON || item.wcStatusObject._wcStatus == MODIFIED;
}

function isItemInConflict(item: RepoItem) {
  return item.wcStatusObject._wcStatus === CONFLICT || item.wcStatusObject._wcStatus === POTENTIAL_CONFLICT;
}

export function getFolderIcon(asset: RepoItem, isExpand = false, isActive = false) {
  var imageSrc = "";
  if (isVersioned(asset)) {
    var itemInConflict = isItemInConflict(asset);
    var itemNotInSync = isItemNotInSync(asset);
    if (itemNotInSync != undefined && !itemInConflict && itemNotInSync != undefined && !itemNotInSync) {
      imageSrc = isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder_checkedout.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder_checkedout.svg') : ThemeSetup.getImageURL('refactor/icons_folder_checkedout.svg');
    } else if (itemNotInSync != undefined && itemNotInSync) {
      imageSrc = isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder_update.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder_update.svg') : ThemeSetup.getImageURL('refactor/icons_folder_update.svg');
    } else if (itemNotInSync != undefined && itemInConflict) {
      imageSrc = isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder_conflict.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder_conflict.svg') : ThemeSetup.getImageURL('refactor/icons_folder_conflict.svg');
    } else {
      imageSrc = isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder.svg') : ThemeSetup.getImageURL('refactor/icons_folder.svg');
    }
  } else if (isNonAliveAsset(asset)) {
    imageSrc = isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder_deleted.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder_deleted.svg') : ThemeSetup.getImageURL('refactor/icons_folder_deleted.svg');
  } else {
    imageSrc =  isActive ? ThemeSetup.getImageURL('refactor/icons_active_folder.svg') : isExpand ? ThemeSetup.getImageURL('refactor/icons_open_folder.svg') : ThemeSetup.getImageURL('refactor/icons_folder.svg');
  }
  return imageSrc;
}